import { apiDaInscricao } from "../../../servicos/axios";

export type Projeto = {
  id: number;
  nome: string;
  programa: string;
  dataInicio: string;
  dataFim: string;
};

export interface RespostaListagemProjetos {
  modelo: Projeto[];
  paginaAtual: number;
  quantidadePorPagina: number;
  totalDeRegistros: number;
  totalDePaginas: number;
}

export const buscarProjetos = async (
  nome: string = "",
  idPrograma?: number,
  paginaAtual: number = 1
): Promise<RespostaListagemProjetos> => {
  const response = await apiDaInscricao().get(`/projeto`, {
    params: {
      nome,
      idPrograma,
      paginaAtual,
    },
  });
  return response.data;
};
